<template>
  <div>
    <slot name="toolbarTop"></slot>
    <div class="buttonBox">
      <div class="left">
        <slot name="toolbarLeft"></slot>
      </div>
      <div class="right">
        <slot name="toolbarRight"></slot>
        <el-tooltip content="刷新数据" placement="top">
          <el-button @click="freshList" icon="el-icon-refresh" size="small">
          </el-button>
        </el-tooltip>
        <el-dropdown @command="changeTableSize">
          <el-button class="table-setting-btn" size="small">
            表格设置 <el-icon class="el-icon-arrow-down"><arrow-down /></el-icon>
          </el-button>
          <template>
            <el-dropdown-menu class="table-setting-menu">
              <el-dropdown-item command="medium">默认</el-dropdown-item>
              <el-dropdown-item command="small">中等</el-dropdown-item>
              <el-dropdown-item command="mini">紧凑</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
    <slot name="toolbarBottom"></slot>
    <el-table :data="table" ref="table" row-key="id" stripe
      :header-cell-style="{ textAlign: 'center', background: '#ebebeb' }" :cell-style="{ textAlign: 'center'}"
      v-bind="maxHeight ? { 'max-height': height } : { 'height': height }" :size="tableSize"
      @expand-change="handleExpandChange" :expand-row-keys="expand" @selection-change="v => multipleSelection = v">
      <slot name="column"></slot>
    </el-table>
  </div>
</template>
<script>
export default {
  props: {
    table: { type: Array, default: () => [] },
    height: { type: String, default: "calc(100vh - 200px)" },
    list: { type: Function, default: () => { } },
    maxHeight: { type: Boolean, default: false },
    expandChange: { type: Function },
  },
  data() {
    return {
      tableSize: "medium",
      expand: [],
      multipleSelection: []
    }
  },
  methods: {
    changeTableSize(cmd) {
      this.tableSize = cmd
      this.$nextTick(() => {
        this.$refs.table.doLayout()
      })
    },
    freshList() {
      this.list()
    },
    handleExpandChange(row, expandedRows) {
      if (expandedRows.length > 0) {
        this.expand = []
        this.expand.push(row.id)
        if (this.expandChange) this.expandChange(row, expandedRows)
      }
    }
  }
}
</script>

<style scoped>
/* selection居中 */
::v-deep .el-table--border .el-table__cell:first-child .cell {
  padding: 0;
  }
/* 斑马纹 */
::v-deep .el-table .el-table__body tr.el-table__row td {
  background: rgb(255, 255, 255);
}
::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td {
  background: rgb(250, 250, 250);
}
/* 表格边框 */
::v-deep .el-table td,
.building-top .el-table th.is-leaf {
  border: none;
}

/* 去掉表头边框 */
::v-deep.el-table thead tr th.is-leaf {
  border: 0px solid #EBEEF5;
  border-right: none;
}

.buttonBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.table-setting-btn {
  min-width: 120px;
}

.table-setting-menu {
  min-width: 120px;
}
</style>